export interface AyuGramConfig {
  isGhostMode: boolean;
  isHideTyping: boolean;
  isAntiDelete: boolean;
  canBypassNoForwards: boolean;
  isStealthStories: boolean;
  canSimulateReadOnReply: boolean;
}

const STORAGE_KEY = 'ayugram_config';

const DEFAULT_CONFIG: AyuGramConfig = {
  isGhostMode: true,
  isHideTyping: true,
  isAntiDelete: true,
  canBypassNoForwards: true,
  isStealthStories: true,
  canSimulateReadOnReply: true,
};

let currentConfig: AyuGramConfig = loadConfig();

function loadConfig(): AyuGramConfig {
  try {
    const raw = typeof window !== 'undefined' ? window.localStorage.getItem(STORAGE_KEY) : undefined;
    if (!raw) {
      return { ...DEFAULT_CONFIG };
    }
    const parsed = JSON.parse(raw) as Partial<AyuGramConfig>;
    return {
      isGhostMode: parsed.isGhostMode ?? DEFAULT_CONFIG.isGhostMode,
      isHideTyping: parsed.isHideTyping ?? DEFAULT_CONFIG.isHideTyping,
      isAntiDelete: parsed.isAntiDelete ?? DEFAULT_CONFIG.isAntiDelete,
      canBypassNoForwards: parsed.canBypassNoForwards ?? DEFAULT_CONFIG.canBypassNoForwards,
      isStealthStories: parsed.isStealthStories ?? DEFAULT_CONFIG.isStealthStories,
      canSimulateReadOnReply: parsed.canSimulateReadOnReply ?? DEFAULT_CONFIG.canSimulateReadOnReply,
    };
  } catch {
    return { ...DEFAULT_CONFIG };
  }
}

export function getAyuGramConfig(): AyuGramConfig {
  return currentConfig;
}

export function updateAyuGramConfig(partial: Partial<AyuGramConfig>): AyuGramConfig {
  currentConfig = {
    ...currentConfig,
    ...partial,
  };

  try {
    if (typeof window !== 'undefined') {
      window.localStorage.setItem(STORAGE_KEY, JSON.stringify(currentConfig));
    }
  } catch {
    // Ignore storage quota errors
  }

  return currentConfig;
}
